<div class="row">
  <div class="col-12">
    <hr style="width: 70%; margin: 5px auto" class="mb-3 mt-3" />
  </div>
  <div class="col-9">
    <h3>Comentários</h3>
  </div>
  <div class="col-3 text-end"><button type="button" class="btn btn-sm btn-outline-secondary"
  (click)="open(content)">Adicionar comentário</button></div>

  @for (comentario of comentarios; track comentario) {
    <div class="col-12">
      <h5 class="m-0">{{comentario.nome}}</h5>
      <small>{{comentario.data | date:"dd/MM/yyyy"}}</small><br />
      <p>{{comentario.comentario}}</p>
      <app-materia-comentario-resposta [id]=comentario.id/>
      <hr style="width: 30%;" class="mb-3 mt-3" />
    </div>
  }

  @if (!comentarios || comentarios.length==0) {
    <div class="col-12">
      <small>Não há comentário para este artigo</small>
    </div>
  }
</div>
<p class="text-end"><small><a class="link-underline-light" (click)="backClicked()" style="cursor: pointer;"><i
class="bi bi-arrow-left-short"></i> Voltar</a></small></p>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Adicionar comentário</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
  </div>
  <form (ngSubmit)="submitForm()" novalidate [formGroup]="formMateriaComentario">
    <div class="modal-body">
      <div class="form-group">
        <label>Nome</label>
        <input type="text" id="nome" name="nome" rows="6" class="form-control" formControlName="nome" />
        @if (submitted && f.nome.errors) {
          <small class="text-danger">
            @if (f.nome.errors.required) {
              <span>O Nome é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Email</label>
        <input type="email" name="email" id="email" class="form-control" formControlName="email" />
        @if (submitted && f.email.errors) {
          <small class="text-danger">
            @if (f.email.errors.required) {
              <span>Email é obrigatório.</span>
            }
            @if (f.email.errors.pattern) {
              <span>Por favor, informe um email válido.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Comentário</label>
        <textarea id="comentario" name="comentario" rows="6" class="form-control"
        formControlName="comentario"></textarea>
        @if (submitted && f.comentario.errors) {
          <small class="text-danger">
            @if (f.comentario.errors.required) {
              <span>Comentário é obrigatório.</span>
            }
          </small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning"
      (click)="c('Close click')">Cancelar</button>
    </div>
    <input type="hidden" name="data" id="data" formControlName="data">
    <input type="hidden" name="id" id="id" formControlName="id">
    <input type="hidden" name="idMateria" id="idMateria" formControlName="idMateria">
  </form>
</ng-template>